import { actionAlert } from "@/utils/cvcMigrationPage";

// Shared by the sections that run actions. `run` wraps one action: it tells the
// page an action is running (`busy`), keeps the failure as an inline alert
// (409 amber "Refused", the rest red with Retry), and always asks the page to
// reload (`changed`) because a timed-out call may still have run. `ask` is the
// simple confirm dialog.
export default {
  props: {
    busy: { type: Boolean, default: false },
  },
  data: () => ({
    loadingKey: "",
    alert: null,
    lastRun: null,
    confirm: { open: false, text: "", proceedText: "OK", run: null },
  }),
  methods: {
    async run (key, call) {
      this.alert = null;
      this.lastRun = { key, call };
      this.loadingKey = key;
      this.$emit("busy", true);
      try {
        return await call();
      } catch (e) {
        this.alert = actionAlert(e);
        return undefined;
      } finally {
        this.loadingKey = "";
        this.$emit("busy", false);
        this.$emit("changed");
      }
    },
    retryLast () {
      if (this.lastRun) this.run(this.lastRun.key, this.lastRun.call);
    },
    ask (text, proceedText, run) {
      this.confirm = { open: true, text, proceedText, run };
    },
    onConfirm (proceed) {
      const run = this.confirm.run;
      this.confirm = { open: false, text: "", proceedText: "OK", run: null };
      if (proceed && run) run();
    },
  },
};
